import React from 'react'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import { Spinner } from 'components/Loaders/Loaders'

export default class Toolbar extends React.Component {
  state = { searchValue: '' }
  clearFilter = () => {
    this.props.onSearchBlur('')
    this.filter.value = ''
    this.setState({ searchValue: '' })
  }
  toggleExpansion = () => {
    this.props.onExpansionChange()
  }
  checkSubmit = e => {
    if (e.keyCode === 13 && this.props.onSearchBlur) {
      this.props.onSearchBlur(e.target.value)
    }
  }
  render() {
    const {
      onSearchBlur,
      onSearchChange,
      searchPlaceholder,
      title,
      className,
      searching,
      underToolbar,
      filterable,
      searchable,
      filter,
      onRequestFilterClear,
      onFilterChange,
      rightAlignChildren
    } = this.props
    return (
      <div className={`table-toolbar ${className}`}>
        <div className="main-wrapper">
          <h1>{title}</h1>
          <div className="right-align">
            {rightAlignChildren}
            {/* <button className='btn btn-secondary btn-small' onClick={this.toggleExpansion}>
              {
                expanded ?
                "Collapse All"
                :
                "Expand All"
              }
            </button> */}
            {
              searchable !== false &&
              <div className="filter-wrapper">
                <input
                  ref={r => {
                    this.filter = r
                  }}
                  type="text"
                  placeholder={searchPlaceholder}
                  onChange={e => {
                    if(onSearchChange) onSearchChange(e.target.value)
                    if(onFilterChange) onFilterChange(e.target.value)
                    if(!filterable){
                      this.setState({ searchValue: e.target.value })
                    }
                  }}
                  onKeyDown={this.checkSubmit}
                  onBlur={e => {if(onSearchBlur)onSearchBlur(e.target.value)}}
                  value={filterable ? filter : undefined}
                />
                {this.state.searchValue && (
                  <button onClick={filterable ? onRequestFilterClear : this.clearFilter}>
                    <CrossIcon alt="Clear Icon" />
                  </button>
                )}
              </div>
            }
            {
              !filterable && searchable !== false &&
              <button className="btn btn-primary toolbar-search-button" disabled={searching}>
                <div className="center-icon">
                  {searching ? (
                    <Spinner size="small" themeColor="inherit" className="list-spinner" />
                  ) : (
                    <SearchIcon alt="Search Icon" />
                  )}
                </div>
              </button>
            }
          </div>
        </div>
        {underToolbar && <div>{underToolbar}</div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/Toolbar.js